import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './shared/Logo';

const Footer: React.FC = () => {
  return (
    <footer style={{
      padding: '60px 24px 40px',
      borderTop: '1px solid var(--border-color)',
      background: '#f8faff',
      position: 'relative',
      zIndex: 1,
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1.5fr 1fr 1fr 1fr',
          gap: 48,
          marginBottom: 48,
        }}>
          <div>
            <Link to="/" style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
              <Logo size={500} />
            </Link>
            <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', lineHeight: 1.6, maxWidth: 280 }}>
              AI-powered software engineers and AI agent teams for enterprise companies.
              Setup in minutes, results on day one.
            </p>
          </div>

          <div>
            <h4 style={{ fontSize: '0.78rem', fontWeight: 700, color: 'var(--text-primary)', marginBottom: 16, textTransform: 'uppercase', letterSpacing: 1.5 }}>
              Products
            </h4>
            {[
              { label: 'AI Engineering', to: '/products' },
              { label: 'AI Teams', to: '/products' },
            ].map((link) => (
              <Link key={link.label} to={link.to}
                style={{ display: 'block', fontSize: '0.88rem', color: 'var(--text-muted)', marginBottom: 12, transition: 'color 0.2s' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--accent-blue)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--text-muted)')}
              >{link.label}</Link>
            ))}
          </div>

          <div>
            <h4 style={{ fontSize: '0.78rem', fontWeight: 700, color: 'var(--text-primary)', marginBottom: 16, textTransform: 'uppercase', letterSpacing: 1.5 }}>
              Company
            </h4>
            {[
              { label: 'About Us', to: '/about' },
              { label: 'Our Clients', to: '/clients' },
              { label: 'Contact', to: '/contact' },
            ].map((link) => (
              <Link key={link.label} to={link.to}
                style={{ display: 'block', fontSize: '0.88rem', color: 'var(--text-muted)', marginBottom: 12, transition: 'color 0.2s' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--accent-blue)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--text-muted)')}
              >{link.label}</Link>
            ))}
          </div>

          <div>
            <h4 style={{ fontSize: '0.78rem', fontWeight: 700, color: 'var(--text-primary)', marginBottom: 16, textTransform: 'uppercase', letterSpacing: 1.5 }}>
              Get Started
            </h4>
            <Link to="/contact" style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              padding: '10px 20px', background: 'var(--gradient-blue)',
              borderRadius: 10, fontSize: '0.82rem', fontWeight: 600, color: 'white',
            }}>
              Schedule Demo
            </Link>
          </div>
        </div>

        <div style={{
          borderTop: '1px solid var(--border-color)', paddingTop: 24,
          display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16,
        }}>
          <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>
            &copy; {new Date().getFullYear()} AI Team. All rights reserved.
          </div>
          <div style={{ display: 'flex', gap: 24 }}>
            {['Privacy Policy', 'Terms of Service', 'Security'].map((label) => (
              <span key={label} style={{ fontSize: '0.78rem', color: 'var(--text-muted)', cursor: 'pointer', transition: 'color 0.2s' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--accent-blue)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--text-muted)')}
              >{label}</span>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) { footer > div > div:first-child { grid-template-columns: 1fr 1fr !important; } }
        @media (max-width: 480px) { footer > div > div:first-child { grid-template-columns: 1fr !important; } }
      `}</style>
    </footer>
  );
};

export default Footer;
